import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImCross } from "react-icons/im";

const MobileNavbar = () => {
  const [isActive, setIsActive] = useState(false);
  const [isSubActive1, setIsSubActive1] = useState(false);
  const [isSubActive2, setIsSubActive2] = useState(false);
  const [isSubActive3, setIsSubActive3] = useState(false);

  const toggleMenu = () => {
    setIsActive((prevState) => !prevState);
    setIsSubActive1(false);
    setIsSubActive2(false);
    setIsSubActive3(false);
  };

  const subMenu1 = () => {
    setIsSubActive1((prevState) => !prevState);
    setIsSubActive2(false);
    setIsSubActive3(false);
  };
  const subMenu2 = () => {
    setIsSubActive2((prevState) => !prevState);
    setIsSubActive1(false);
    setIsSubActive3(false);
  };

  const subMenu3 = () => {
    setIsSubActive3((prevState) => !prevState);
    setIsSubActive2(false);
    setIsSubActive1(false);
  };

  return (
    <div className="navbarr">
      <nav className="">
        <ul className={`menuu ${isActive ? "activee" : ""}`}>
          <li className="logoo">
            <a href="https://scorechain.com/">
              <div className="css-zg1vud" style={{ width: 164, height: 32 }}>
                <svg
                  viewBox="0 0 4053 853"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M812.002 98.1178L433.881 560.898L229.226 356.24C218.178 345.192 211.97 330.209 211.97 314.585C211.97 298.961 218.178 283.975 229.226 272.927C240.274 261.879 255.257 255.673 270.881 255.673C286.506 255.673 301.489 261.879 312.537 272.927L434.004 394.393L812.124 97.8965"
                    fill="#28BEF3"
                  />
                  <path
                    d="M545.088 141.044L595.319 34.3031C546.337 13.2923 493.85 1.65838 440.578 0H438.128L441.754 117.886C477.279 119.562 512.244 127.399 545.088 141.044Z"
                    fill="#123841"
                  />
                  <path
                    d="M117.823 416.025C118.896 382.611 125.411 349.596 137.108 318.278L29.0214 270.984C2.7854 338.533 -5.86135 411.639 3.89378 483.443C13.6489 555.248 41.4862 623.399 84.7923 681.5L176.583 607.45C136.176 551.99 115.49 484.603 117.823 416.025Z"
                    fill="#123841"
                  />
                  <path
                    d="M448.656 734.309L447.723 852.246C501.702 849.716 554.698 836.864 603.84 814.387L551.132 708.824C518.706 723.187 484.033 731.811 448.656 734.309Z"
                    fill="#123841"
                  />
                  <path
                    d="M201.083 637.125L109.217 711.226C111.153 713.382 113.112 715.561 115.121 717.693C191.456 799.737 297.186 848.197 409.168 852.465L410.099 734.848C330.394 730.596 255.456 695.559 201.083 637.125Z"
                    fill="#123841"
                  />
                  <path
                    d="M403.316 118.231L399.689 0.611328C325.113 5.38265 253.088 29.6132 190.791 70.8866C128.494 112.16 78.0998 169.038 44.6279 235.851L152.814 283.19C177.169 236.72 212.935 197.204 256.753 168.349C300.572 139.494 351.004 122.248 403.316 118.231Z"
                    fill="#123841"
                  />
                  <path
                    d="M852.167 453.247L734.377 450.797C730.423 499.797 714.833 547.147 688.905 588.913C662.976 630.678 627.457 665.653 585.295 690.933L638.075 796.619C666.918 780.069 693.743 760.228 718.009 737.491C797.533 663.459 845.563 561.696 852.167 453.247Z"
                    fill="#123841"
                  />
                  <path
                    d="M735.083 412.423L852.874 414.876C851.568 361.355 840.135 308.566 819.181 259.301L713.029 311.102C726.082 343.379 733.541 377.641 735.083 412.423Z"
                    fill="#123841"
                  />
                  <path
                    d="M435.437 565.818L433.842 394.512L811.963 98.0156"
                    fill="url(#paint0_linear)"
                  />
                  <path
                    d="M1168.94 606.965C1244.44 606.965 1290.44 569.965 1290.44 510.465C1290.44 447.965 1237.44 426.465 1182.44 413.965C1137.44 403.465 1105.94 397.965 1105.94 362.465C1105.94 332.465 1132.44 312.965 1172.94 312.965C1210.44 312.965 1242.44 331.965 1259.44 356.465C1260.44 357.965 1283.44 346.465 1283.44 327.965C1283.44 304.465 1244.44 270.465 1172.44 270.465C1103.44 270.465 1055.94 309.465 1055.94 364.465C1055.94 429.965 1107.94 447.465 1157.94 458.965C1200.94 468.965 1238.94 477.465 1238.94 513.965C1238.94 545.965 1213.44 564.465 1168.44 564.465C1123.94 564.465 1089.44 541.965 1070.94 514.965C1069.44 512.965 1047.44 525.465 1047.44 542.465C1047.44 568.965 1090.94 606.965 1168.94 606.965ZM1493.29 606.965C1579.29 606.965 1621.79 555.465 1621.79 531.465C1621.79 507.465 1590.79 501.465 1589.79 503.965C1576.29 538.965 1539.79 560.465 1496.29 560.465C1431.29 560.465 1383.79 509.965 1383.79 438.465C1383.79 366.465 1429.79 316.965 1495.29 316.965C1531.79 316.965 1568.29 334.465 1586.79 366.965C1587.79 368.965 1616.79 362.965 1616.79 338.965C1616.79 316.465 1575.79 270.465 1494.79 270.465C1397.79 270.465 1330.29 340.465 1330.29 439.465C1330.29 537.965 1397.29 606.965 1493.29 606.965ZM1821.91 606.965C1917.91 606.965 1985.91 537.465 1985.91 438.465C1985.91 339.465 1918.91 270.465 1822.41 270.465C1726.91 270.465 1658.41 340.465 1658.41 439.465C1658.41 537.965 1725.41 606.965 1821.91 606.965ZM1822.41 561.465C1756.91 561.465 1710.41 510.465 1710.41 438.465C1710.41 365.965 1756.41 315.965 1821.91 315.965C1887.41 315.965 1933.91 367.465 1933.91 439.465C1933.91 511.465 1887.91 561.465 1822.41 561.465ZM2092.51 433.465V319.465H2159.01C2206.51 319.465 2230.51 338.965 2230.51 376.465C2230.51 411.465 2208.01 433.465 2160.51 433.465H2092.51ZM2186.01 468.965C2249.01 463.965 2282.51 428.965 2282.51 373.965C2282.51 309.965 2240.51 276.965 2161.51 276.965H2069.51C2053.01 276.965 2042.01 288.465 2042.01 305.965V575.965C2042.01 592.965 2049.51 602.465 2063.51 602.465H2070.51C2085.51 602.465 2093.01 592.965 2093.01 578.965V473.965H2128.51L2217.01 582.465C2228.01 596.965 2237.01 602.465 2250.51 602.465C2272.01 602.465 2283.01 584.465 2280.51 581.465L2186.01 468.965ZM2363.94 600.465H2554.44C2570.44 600.465 2577.94 592.465 2577.94 577.965V575.465C2577.94 561.965 2570.44 554.965 2554.44 554.965H2387.94V456.965H2514.44C2530.44 456.965 2538.44 449.465 2538.44 435.465V433.965C2538.44 420.465 2530.94 413.465 2514.44 413.465H2387.94V322.965H2551.44C2567.44 322.965 2575.44 315.465 2575.44 301.465V298.465C2575.44 284.965 2567.44 276.965 2551.44 276.965H2363.94C2347.44 276.965 2336.44 288.465 2336.44 305.965V571.965C2336.44 589.465 2347.44 600.465 2363.94 600.465ZM2780.4 606.965C2866.4 606.965 2908.9 555.465 2908.9 531.465C2908.9 507.465 2877.9 501.465 2876.9 503.965C2863.4 538.965 2826.9 560.465 2783.4 560.465C2718.4 560.465 2670.9 509.965 2670.9 438.465C2670.9 366.465 2716.9 316.965 2782.4 316.965C2818.9 316.965 2855.4 334.465 2873.9 366.965C2874.9 368.965 2903.9 362.965 2903.9 338.965C2903.9 316.465 2862.9 270.465 2781.9 270.465C2684.9 270.465 2617.4 340.465 2617.4 439.465C2617.4 537.965 2684.4 606.965 2780.4 606.965ZM2980.01 602.465H2987.51C3002.51 602.465 3010.01 594.465 3010.01 578.965V460.965H3180.51V578.965C3180.51 594.465 3188.01 602.465 3202.01 602.465H3209.51C3224.51 602.465 3232.01 594.465 3232.01 578.965V298.465C3232.01 282.965 3224.51 274.965 3209.51 274.965H3202.01C3188.01 274.965 3180.51 282.965 3180.51 298.465V415.965H3010.01V298.465C3010.01 282.965 3002.51 274.965 2987.51 274.965H2980.01C2966.01 274.965 2958.51 282.965 2958.51 298.465V578.965C2958.51 594.465 2966.01 602.465 2980.01 602.465ZM3370.3 463.965L3422.8 326.965L3474.8 463.965H3370.3ZM3487.3 505.465L3515.8 578.965C3522.8 597.465 3534.8 602.965 3546.3 602.965C3561.8 602.965 3576.3 591.465 3574.8 587.465L3458.8 290.465C3454.8 279.965 3447.3 273.965 3423.3 273.965C3399.8 273.965 3391.8 279.965 3387.8 290.465L3272.8 587.465C3271.3 591.965 3285.8 602.965 3300.8 602.965C3311.8 602.965 3322.8 597.465 3329.3 579.465L3357.8 505.465H3487.3ZM3642.24 602.465H3649.24C3664.24 602.465 3671.74 594.465 3671.74 578.965V298.465C3671.74 282.965 3664.24 274.965 3649.24 274.965H3642.24C3627.74 274.965 3620.24 282.965 3620.24 298.465V578.965C3620.24 594.465 3627.74 602.465 3642.24 602.465ZM3766.14 602.465H3771.64C3786.64 602.465 3793.64 594.465 3793.64 578.965V348.465L3962.14 586.965C3970.14 597.965 3974.14 602.465 3989.64 602.465H3993.64C4008.64 602.465 4017.64 591.465 4017.64 573.465V298.465C4017.64 282.965 4010.64 274.965 3996.64 274.965H3990.64C3975.64 274.965 3969.14 282.965 3969.14 298.465V521.465L3809.14 294.465C3799.64 281.465 3793.64 274.965 3778.14 274.965H3769.64C3753.64 274.965 3745.14 286.465 3745.14 303.965V578.965C3745.14 594.465 3751.64 602.465 3766.14 602.465Z"
                    fill="#66CEF5"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="433.842"
                      y1="331.917"
                      x2="811.963"
                      y2="331.917"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#229AC5" />
                      <stop offset="0.171" stopColor="#24A7D6" />
                      <stop offset="0.396" stopColor="#26B4E6" />
                      <stop offset="0.652" stopColor="#27BBF0" />
                      <stop offset={1} stopColor="#28BEF3" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </a>
          </li>
          <li className="itemm has-submenuu">
            <a href="#/" tabIndex={0} onClick={subMenu1}>
              CUSTOMERS
            </a>
            <ul className={isSubActive1 ? "submenu-activee " : "submenuu"}>
              <li className="subitemm">
                <a href="https://scorechain.com/customers/financial-institutions">
                  Financial Institutes
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/customers/crypto-businesses">
                  Crypto Businessess
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/customers/government-and-agencies">
                  Govenament and agencies
                </a>
              </li>
            </ul>
          </li>
          <li className="itemm has-submenuu">
            <a href="#/" tabIndex={0} onClick={subMenu2}>
              SOLUTIONS
            </a>
            <ul className={isSubActive2 ? "submenu-activee" : "submenuu"}>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/crypto-analytics">
                  Scorchain Analytics
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/crypto-exploration-tool">
                  Exploration Tool
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/vasp-entity-directory">
                  Entity Directory
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/case-manager">
                  Case Mangager
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/alerts-and-KYA-KYT-reports">
                  Reports and alerts
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/customization">
                  Customization
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/travel-rule">
                  Travel rule
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/nft-aml-compliance-reports">
                  NFT AML compliance
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/solutions/crypto-investigation">
                  Crypto Investigation
                </a>
              </li>
            </ul>
          </li>
          <li className="itemm has-submenuu">
            <a href="#/" tabIndex={0} onClick={subMenu3}>
              Resources
            </a>
            <ul className={isSubActive3 ? "submenu-activee" : "submenuu"}>
              <li className="subitemm">
                <a href="https://scorechain.com/resources/crypto-guidelines-and-regulations">
                  Guidelines and regulation
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/resources/academy">
                  Scorechain Academy
                </a>
              </li>
              <li className="subitemm">
                <a href="https://scorechain.com/resources/who-we-are">
                  Who we are
                </a>
              </li>
              <li>
                <a href="https://scorechain.com/resources/crypto-glossary">
                  Glossary
                </a>
              </li>
            </ul>
          </li>
          <li className="itemm">
            <a
              target="_blank"
              href="https://lp.scorechain.com/partnerships?utm_source=mainwebsite&utm_medium=link&utm_campaign=header"
              rel="noreferrer"
            >
              PARTNERS
            </a>
          </li>
          <li className="itemm">
            <a href="https://scorechain.com/blog">Blog</a>
          </li>
          <li className="itemm buttonn">
            <a href="https://connect.scorechain.com/login">Sign In</a>
          </li>
          <li className="itemm buttonn secondaryy">
            <a href="https://scorechain.com/contact-us">Contact</a>
          </li>
          <li
            className={`togglee ${isActive ? "activee" : ""}`}
            onClick={toggleMenu}
          >
            <a href="#/">{isActive ? <ImCross /> : <GiHamburgerMenu />}</a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MobileNavbar;
